import MessageSidebar from './message-sidebar-container';

export default MessageSidebar;
